export default __webpack_public_path__ + "static/media/IMG_9773.635bb04e.JPG";